module.exports = __webpack_public_path__ + "static/Olympo34-5544d0399b7a625525bffee8927a913d.mp4";